import qs, { type ParsedQs } from "qs";

export function addSearchParamsToURL(url: string, params: ParsedQs) {
  const [baseUrl, queryString] = url.split("?");
  const existingParams: ParsedQs = queryString ? qs.parse(queryString) : {};
  const mergedQueryString = qs.stringify({ ...existingParams, ...params });

  return mergedQueryString ? `${baseUrl}?${mergedQueryString}` : baseUrl;
}
